module.exports = __webpack_public_path__ + "static/media/home-img4.8bc239bc.png";